import React from 'react';
import { IconProps } from './icon.types';

function IconEmail(props: IconProps) {
  const { customClassName = '', customStyle = {} } = props;

  return (
    <svg
      className={customClassName}
      style={customStyle}
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 8.83203H10C6.66667 8.83203 5 10.4987 5 13.832V28.832C5 32.1654 6.66667 33.832 10 33.832H30C33.3333 33.832 35 32.1654 35 28.832V13.832C35 10.4987 33.3333 8.83203 30 8.83203ZM29.9015 16.5087L21.7151 22.462C21.2018 22.8354 20.6 23.022 20 23.022C19.4 23.022 18.7966 22.8354 18.2849 22.4637L10.0985 16.5087C9.54014 16.1037 9.41674 15.3204 9.82341 14.762C10.2284 14.2054 11.0065 14.0787 11.5698 14.487L19.7567 20.4404C19.9033 20.5454 20.0983 20.547 20.245 20.4404L28.4318 14.487C28.9935 14.0787 29.7732 14.2054 30.1782 14.762C30.5849 15.322 30.4599 16.1037 29.9015 16.5087Z"
        fill="#697186"
      />
    </svg>
  );
}

export default IconEmail;
